import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ProcessProgress } from './ProcessProgress';
import { AbstractService } from '@app/shared/service/base/abstractService';
import { EnvironmentService } from '../environment/environment.service';
import { Router } from '@angular/router';
import { ErrorService } from '../error/error.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProcessProgressService extends AbstractService {

  finish: () => void;
  error: () => void;
  update: (procesProgress: ProcessProgress) => void;
  processProgress: ProcessProgress;


  private subject: Subject<ProcessProgress> = new Subject();
  private isLoading = false;

  constructor(
    public environmentService: EnvironmentService,
    public router: Router,
    public errorService: ErrorService,
    private httpClient: HttpClient
  ) {
    super(environmentService, router, errorService);
  }

  getSubject(): Observable<ProcessProgress> {
    return this.subject.asObservable();
  }

  start(
      processProgress: ProcessProgress,
      finish: () => void,
      error: () => void,
      update: (procesProgress: ProcessProgress) => void,
      refreshTime: number = 1000
  ): void {
    this.finish = finish;
    this.error = error;
    this.update = update;
    processProgress.action = 'start';
    this.processProgress = processProgress;
    this.subject.next(processProgress);
    this.isLoading = true;
    this.refreshStatus(refreshTime);
  }

  refreshStatus(refreshTime: number): void {
    if (this.isLoading) {
      const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/ProcessProgress/${this.processProgress.id}`;
      const observable: Observable<ProcessProgress> = this.httpClient.get<ProcessProgress>(urlApi, {headers: this.getHeaders()})
        // añadimos el manejo de errores
        .pipe(catchError((error: HttpErrorResponse) => this.handleError(
              error,
              true,
              'entity.processProgress.error.get'
            )));
      observable.subscribe(
        (progress: ProcessProgress) => {
          if (progress) {
            if (progress.error) {
              void this.errorService.showError(progress.errorCode);
              this.error();
            } else if (progress.finish) {
              this.finish();
            } else {
              this.update(progress);
              setTimeout(() => {
                this.refreshStatus(refreshTime);
              }, refreshTime);
            }
          } else {
            void this.errorService.showError('entity.season.error.insert');
          }
        }
      );
    }
  }

  remove(): void {
    const urlApi = `${this.baseBackUrl}${this.baseApiUrl}/ProcessProgress/${this.processProgress.id}`;
    const observable: Observable<ProcessProgress> = this.httpClient.delete<ProcessProgress>(urlApi, {headers: this.getHeaders()});
    observable.subscribe();
  }

}
